import $ from 'jquery';
import _ from 'lodash';
import ComponentBasePrototype from 'ComponentBasePrototype';
import Carousel from './carousel';

export default class CarouselLoader extends ComponentBasePrototype {
  build () {
    const nodeEle = this.node;
    Carousel.build(nodeEle);
  }
}
